<template>
  <div class="card p-6 pt-7">
    <button class="delete" @click="close"></button>
    <div class="is-flex is-flex-direction-column">
      <p class="has-text-weight-bold is-size-3 mb-5">
        {{ $t("mp:new_application.modal.fail.title") }}
      </p>
      <div class="is-flex is-flex-direction-row is-align-items-center mb-5">
        <b-icon
          icon-pack="fas"
          icon="exclamation-triangle"
          size="is-large"
          type="is-danger"
        />
        <p class="ml-3">
          {{ $t("mp:new_application.modal.fail.message") }}
        </p>
      </div>
      <p class="mb-5">
        {{ $t("mp:new_application.modal.fail.contact_us") }}
      </p>
    </div>
    <b-button @click="close" type="is-blue"
      >{{ $t("mp:new_application.button.retry") }}
    </b-button>
  </div>
</template>
<script>
export default {
  name: "BnplApplicationFail",
  methods: {
    close() {
      this.$parent.close();
    },
  },
};
</script>
<style lang="scss">
.card {
  // position: relative;
  border-radius: 24px;

  button.delete {
    position: absolute;
    top: 16px;
    right: 16px;
  }

  input.input {
    cursor: text !important;
  }

  .control.has-icons-right .icon {
    color: #051c3a;
  }
}
</style>
